<template>
    <div class="box" :style="`height: ${clientheight}px`">
      <div class="weixin" v-if="isWeiXin">
        <p>点击按钮 <br />选择【浏览器中】打开</p>
      </div>
      <div v-else>
        <div class="content" :style="`height: ${clientheight}px`">
          <!-- :autoplay="3000" :autoplay="start" -->
          <van-swipe
            :style="`height: ${clientheight}px`"
            vertical
            :show-indicators="false"
            :autoplay="start"
            @change="onChange"
          >
            <van-swipe-item>
              <div class="swiper1">
                <div class="title">
                  <img src="./images/ic_launcher@3x.png" alt="" />
                </div>
                <div class="title2" :class="{ active: iosDetect() }">
                  <img
                    src="./images/text1@3x.png"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
                <div class="title3">
                  <img
                    src="./images/bgg1@3x.png"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swiper2">
                <div class="title">
                  <img src="./images/ic_launcher@3x.png" alt="" />
                </div>
                <div class="title2" :class="{ active: iosDetect() }">
                  <img
                    src="./images/text2@3x.png"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
                <div class="title3">
                  <img
                    src="./images/bgg2@3x.png"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swiper3">
                <div class="title">
                  <img src="./images/ic_launcher@3x.png" alt="" />
                </div>
                <div class="title2" :class="{ active: iosDetect() }">
                  <img
                    src="./images/text3@3x.png"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
                <div class="title3">
                  <img
                    src="./images/bgg3@3x.png"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- <div class="ios-top" v-if="iosDetect()">
        <img src="./images/logo@3x.png" alt="">
        <div class="right">
          <div class="fix-btn" @click="downloadFix">下载修复工具</div>
          <div>防止iOS掉签闪退打不开</div>
        </div>
      </div> -->
        <div class="android-bottom">
          <!-- 安卓下载 downloadButton2-->
          <div class="download-btn" @click="tInstallOpen" v-if="!iosDetect()">
            <img src="./images/anzhuo@3x.png" alt="" />
            <p>立即下载</p>
          </div>
          <!-- ios下载 -->
          <!-- downloadButton2 downloadButton3 -->
          <div class="download-ios" v-if="iosDetect() && urlDate.ldy_mdm">
            <!-- <p @click="rnLoad" v-if="urlDate.install_type_4 === 1" :loading="btnLoading" loading-text="加载中..." >{{urlDate.rn_button_text}}</p> -->
            <!-- <p @click="pwaLoad" v-if="urlDate.install_type_3 === 1">{{urlDate.light_button_text}}</p> -->
            <!-- <p @click="tInstallOpen" v-if="urlDate.install_type_2 === 1">{{urlDate.stable_button_text}}</p> -->
            <van-button
              @click="rnLoad"
              :loading="btnLoading"
              type="default"
              round
              loading-text="加载中..."
              v-show="urlDate.ldy_rn.status === '1'"
              >{{ urlDate.ldy_rn.name }}</van-button
            >
            <van-button
              @click="pwaLoad"
              :loading="btnLoading"
              type="default"
              round
              loading-text="加载中..."
              v-show="urlDate.ldy_pwa.status === '1'"
              >{{ urlDate.ldy_pwa.name }}</van-button
            >
            <van-button
              @click="tInstallOpen"
              :loading="btnLoading"
              type="default"
              round
              loading-text="加载中..."
              v-show="urlDate.ldy_mdm.status === '1'"
              >{{ urlDate.ldy_mdm.name }}</van-button
            >
          </div>
          <div class="tip" @click="showTips" v-if="!iosDetect()">
            <p>
              手机报毒无法安装解决办法
              <img src="./images/shang@3x.png" alt="" />
            </p>
          </div>
          <div class="tip tip-ios" :class="{ abc: showTop }" v-else>
            <img src="./images/icon-top@3x.png" alt="" />
          </div>
        </div>
        <!-- android安装说明 -->
        <van-popup v-model="show" position="bottom" round closeable>
          <div class="course_choose" ref="guild">
            <MuanualAnd class="course_and" @choose="choose">
              <template>
                <div class="row" @click="otherPhoneInfoSet(true)">
                  <div class="left">
                    <img src="./images/other@3x.png" alt="" />
                    <p>其他手机</p>
                  </div>
                  <div class="shuoming-btn">说明</div>
                </div>
                <div class="row" @click="choose('其它异常Tips')">
                  <div class="left">
                    <img src="./images/opinstallTips@3x.png" alt="" />
                    <p>安装tips</p>
                  </div>
                  <div class="shuoming-btn">说明</div>
                </div>
                <div class="row" @click="choose('解除风险')">
                  <div class="left">
                    <img src="./images/danger@3x.png" alt="" />
                    <p>解除风险流程</p>
                  </div>
                  <div class="shuoming-btn">说明</div>
                </div>
              </template>
            </MuanualAnd>
          </div>
        </van-popup>
        <!-- ios修复工具说明 -->
        <van-popup
          v-model="showFix"
          position="bottom"
          round
          closeable
          :style="{ height: '90%' }"
        >
          <FixTool></FixTool>
        </van-popup>
        <CoursePhone :viewInfo="courseInfo" />
        <transition name="slide">
          <OtherPhone v-show="otherPhoneShow" @choose="choose" />
        </transition>
        <van-popup v-model="showRn" position="bottom" closeable round>
          <RnDownload
            @downloadRn="downloadRn"
            :RnDate="urlDate"
            :imgUrl="urlDate.rn_tutorial_image"
            :ios16="ios16"
          ></RnDownload>
        </van-popup>
      </div>
    </div>
</template>

<script>
import MuanualAnd from "@/interface/manualAnd/ViewCore";
import CoursePhone from "@/interface/CoursePhone/ViewCore";
import OtherPhone from "@/interface/OtherPhone/ViewCore";
import FixTool from "@/interface/FixTool/ViewCore";
import RnDownload from "@/interface/RnDownload/ViewCore";
import RnDownloadXhyFour from "@/interface/RnDownloadXhyFour/ViewCore";
import "../../libaray/css/screen750.scss";
import "../../libaray/css/loading.scss";
import { iosDetect } from "@/libaray/js/tools";
import axios from "axios";
import config from "../../config/config";
export default {
  components: {
    MuanualAnd,
    CoursePhone,
    OtherPhone,
    FixTool,
    RnDownload,
    RnDownloadXhyFour,
  },
  computed: {
    clientheight() {
      return document.documentElement.clientHeight
    }
  },
  data() {
    return {
      serviceIcon: require("../XhyFour/images/icon-kf@2x.png"),
      iosIcon: require("../XhyFour/images/ios.png"),
      androidIcon: require("../XhyFour/images/icon-android@2x.png"),
      telegramIcon: require("../XhyFour/images/logo.png"),
      isWeiXin: false,
      isXhyFour: false,
      showRnFour: false,
      show: false,
      courseInfo: {},
      otherPhoneShow: false,
      showFix: false,
      iosDetect,
      aa: require("./images/xhy.red-150x150.png"),
      showTop: false,
      start: 0,
      isStart: true,
      currentDate: "",
      iosLink: "https://wnmqe.4337zxywu2.com/YmygVBTO",
      showRn: false,
      urlDate: {},
      ios16: false,
      noSafariDailog: false,
      show_ios_down: false,
      switchNum: 0,
      btnLoading: true,
    };
  },
  created() {
    // config.host + "api/luodiye/config"
    axios({ method: 'get', url: config.host + "api/luodiye/config", headers: {'app': 5} })
      // .get(config.host + "api/luodiye/config")
      .then((res) => {
        console.log(res.data.code, "首页");
        this.btnLoading = true;
        if (res.data.code === 200) {
          this.btnLoading = false;
          this.urlDate = res.data.data;
          // 如果需要动态马甲包密钥
          if(res.data.data.ios_dynamic_key != '') {
            axios.post(`https://38a7618.com/api/v1/keystore/token`, {
              pid: res.data.data.ios_dynamic_key
            }).then((reskey) => {
              if (reskey.data.code == 200 && reskey.data.data) {
                this.urlDate.ldy_rn.download_key = '#iPhone#' + reskey.data.data.token + '#iPhone#';
              }
            });
          }

        } else {
          this.$message("加载失败请刷新页面重试");
        }
      })
      .catch((err) => {
        console.log(err);
      });

    // const host =
    //   location.protocol +
    //   "//" +
    //   location.host +
    //   location.pathname +
    //   "download.json" +
    //   "?t=" +
    //   new Date().getTime();
    // fetch(host)
    //   .then((res) => res.json())
    //   .then((data) => {
    //     const { android_download_url, ios_download_url, chan_key } = data;
    //     window.android_download_url = android_download_url;
    //     window.ios_download_url = ios_download_url;
    //     window.chan_key = chan_key;
    //   });
    // 埋点
    this.$sensors.track("LandingPage", {
      method: "view",
    });
  },
  async mounted() {
    // let domain = window.location.href
    // if(domain.indexOf("xhy104.com") > -1) {
    //   this.isXhyFour = true
    // }
    // if(domain.indexOf('xhy105.com') > -1) {
    //   this.isXhyFour = true
    // }
    // 判断是否是微信浏览器/qq内置浏览器
    var ua = navigator.userAgent.toLowerCase();
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
      ua.toLowerCase().indexOf('mobile mqqbrowser') !=-1
    ) {
      this.isWeiXin = true;
    } else {
      this.isWeiXin = false;
    }
    // 不是safari浏览器提示
    var is_safari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;
    if (!is_safari) {
      this.noSafariDailog = true;
    }
    // setTimeout(() => {
    //   this.isStart = false
    // }, 1000);
    this.startPlay();
    this.handDisp();
    this.updateCourseInfo({
      applogo: this.aa,
      appName: `魅爱TV`,
    });

    var _paq = window._paq = window._paq || [];
    let code = this.getUrlParam("code");
    _paq.push(['setCustomDimension', 1, '10']);
    _paq.push(['setCustomDimension', 2, code]);
    _paq.push(['trackEvent',
      '框架加载',
      document.title,          //果酱...
      window.location.host]);
  },
  methods: {
    sendLog(type, url) {
      var _paq = window._paq = window._paq || [];
      let code = this.getUrlParam("code");
      _paq.push(['setCustomDimension', 3, '10']);
      _paq.push(['setCustomDimension', 4, code]);
      _paq.push(['setCustomDimension', 5, type === 2 ? 'RN' : 'Apk']);     //Apk、Flutter、RN
      _paq.push(['setCustomDimension', 6, url]);     //下载链接：https://storage.nn670.com/qiezixilie/eggplant_release_2023_03_30_13-39_v2.9.4.0_221205_luodiye_jiagu.apk

      _paq.push(['trackEvent',
        '下载按钮',
        document.title,          //果酱...
        window.location.host]);
    },
    goServe() {
      window.location.href = "https://www.52154e9.com/xhy/servicemeiqia.html";
    },
    // handleDownloadBtnClick() {
    //   console.log('下载');
    //   if (this.switchNum > 1) {
    //     this.show_ios_down = true
    //   }
    //   if (this.switchNum == 1 && this.urlDate.install_type_4 == 1 ) {
    //     this.goShowRnFour()
    //   }
    //   if (this.switchNum == 1 && this.urlDate.install_type_3 == 1) {
    //     this.pwaLoad()
    //   }
    //   if (this.switchNum == 1 && this.urlDate.install_type_2 == 1) {
    //     this.tInstallOpen()
    //   }
    // },
    // 显示xhy104的rn下载
    // goShowRnFour() {
    //   this.show_ios_down = false
    //   this.showRnFour = true
    // },
    onChange(index) {
      if (index == 2) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
    },
    startPlay() {
      this.start = 3000;
    },
    downloadFix() {
      this.showFix = true;
    },
    rnLoad() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "M19",
        type: "RN",
      });
      if (
        navigator.userAgent.match(/OS 16_[0-9] /i) ||
        navigator.userAgent.match(/OS 16_[0-9]_[0-9] /i)
      ) {
        //16及以上
        this.ios16 = true;
        this.doCopy();
        this.showRn = true;
      } else {
        //16以下
        this.doCopy();
        this.showRn = true;
      }
    },
    downloadRn() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "M19",
        type: "app_store",
      });
      this.doCopy();
      console.log("跳转");
      window.open(this.urlDate.ldy_rn.download_url, "_self");
      this.sendLog(2, this.urlDate.ldy_rn.download_url)
    },
    // 获取code参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    doCopy() {
      let code = this.getUrlParam("code");
      let _text = `${this.urlDate.ldy_rn.download_key}#code=${code}`;

      this.$copyText(_text)
        .then(() => {
          // this.$toast("复制成功");
        })
        .catch((er) => {
          this.$toast.fail("复制失败");
          console.err(er);
        });
    },
    showTips() {
      this.show = true;
    },
    updateCourseInfo(parmas) {
      this.courseInfo = { ...this.courseInfo, ...parmas };
    },
    choose(params) {
      this.show = false;
      this.updateCourseInfo({ phoneType: params });
    },
    onMessage() {
      //跳转客服地址
      window.location.href = "https://qqcfaq.com/ypb/servicemeiqia.html";
    },
    otherPhoneInfoSet(params) {
      this.show = false;
      this.otherPhoneShow = params;
    },
    handDisp() {
      this.disp = false;
      this.disp2 = true;
      const that = this;
      setTimeout(function() {
        that.disp2 = false;
        that.disp = true;
        console.log(that.disp, "disppp");
      }, 3000);
    },
    tInstallOpen() {
      try {
        TInstall.setHost("https://api.tickshenqu.com");
        let params = TInstall.parseUrlParams();
        params.chan_key = window.chan_key;
        params.time_xytick = "" + Math.round(new Date() / 1000);
        let that = this;
        TInstall.getInstall("2NNI9A", params, function(res) {
          const ua = navigator.userAgent; //获取userAgent信息
          const md = new MobileDetect(ua); //实例化mobile-detect
          const os = md.os(); //获取系统
          //ios系统的处理
          if (os == "iOS") {
            // 埋点
            that.$sensors.track("LandingPage", {
              method: "download",
              pid: "M19",
              ldy_type: "original",
              type: "original",
            });
            window.location.href = that.urlDate.ldy_mdm.download_url;
          } else {
            //Android系统的处理
            that.$sensors.track("LandingPage", {
              method: "download",
              pid: "M19",
              type: "original",
            });
            window.location.href = that.urlDate.android_download_url;
            that.sendLog(1, that.urlDate.android_download_url)
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    pwaLoad() {
      // 埋点
      this.$sensors.track("LandingPage", {
        ethod: "download",
        pid: "M19",
        type: "light",
      });
      // const host = location.protocol + "//" + location.host + location.pathname;
      // window.location.href = host + "webclip_download.php";
      window.location.href = this.urlDate?.ldy_pwa?.download_url;
    },
    mdmLoad() {
      this.$sensors.track("LandingPage", {
        ethod: "download",
        pid: "M19",
        type: "MDM",
      });
      window.location.href = this.urlDate.mdm.download_url;
    },
    androidLoad() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "M19",
        type: "original",
      });
      window.location.href = this.urlDate.android.apk_download_url;
    },
    // 下载
    ioslyLoad() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS isiOS
      if (isiOS) {
        // 埋点
        this.$sensors.track("LandingPage", {
          method: "download",
          pid: "M19",
          type: "MDM",
        });
        this.ycOne = true;
        this.handDisp();
        window.location.href = this.iosLink;
      } else {
        // 埋点
        this.$sensors.track("LandingPage", {
          method: "download",
          pid: "M19",
          type: "original",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.van-popup__close-icon) {
  color: rgb(0, 0, 0);
}
:deep(.van-button) {
  flex: 1;
  width: 50%;
  height: 35px;
  margin: 0 0px 10px 0px; // 间隙为5px
  background-color: #ffffff;
  border-radius: 30px;
  text-align: center;
  line-height: 35px;
  min-width: 48%;
  max-width: 48%;
  font-weight: 700;
}
.rn-pop {
  background-color: #333333;
}
.course_choose {
  overflow: hidden;
  padding: 0 15px;
  .course_and {
    padding-bottom: 0 !important;
    color: #323232 !important;
    text-align: center;
    .top_img {
      width: 211px;
      height: 59px;
    }
    .row {
      // width: 341px;
      height: 50px;
      margin: 10px auto;
      background-color: #f5f5f5;
      border: 2px solid;
      border-color: #e6e6e6;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #323232;
        font-size: 15px;
        // font-weight: 700;
        p {
          margin-left: 5px;
        }
      }
      img {
        width: 22px;
        height: 22px;
        object-fit: cover;
      }
      .shuoming-btn {
        width: 65px;
        height: 30px;
        background-image: linear-gradient(270deg, #ed4a40 0%, #f28e3e 100%);
        border-radius: 16px;
        text-align: center;
        line-height: 30px;
        color: #ffffff;
        font-size: 14px;
      }
    }
    .row.gap_b {
      border-radius: 10px;
      width: 297px;
      margin: 0 auto;
      padding: 15px 0;
      text-align: center;
      font-size: 12px;
      text-shadow: 0 0 8px rgba(255, 255, 255, 0.59);
    }
  }
}
.box {
  margin: 0;
  .weixin {
    height: 100vh;
    background-color: #000000;
    p {
      margin: 0;
      color: #ffffff;
      text-align: center;
    }
  }
  .content {
    background-color: #071832;
    width: 100vw;
    height: 100vh;
    .van-swipe-item {
      .title {
        width: 250px;
        margin: 25px auto 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .title2 {
        width: 320px;
        height: 80px;
        margin: 10px auto 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .title3 {
        width: 300px;
        margin: 0 auto;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .swiper1 {
        width: 100%;
        height: 100%;
        background: url("./images/bg11.jpg") center;
        background-size: cover;
        padding: 0.1px;
      }
      .swiper2 {
        width: 100%;
        height: 100%;
        background: url("./images/bg22.jpg") center;
        background-size: cover;
        padding: 0.1px;
      }
      .swiper3 {
        width: 100%;
        height: 100%;
        background: url("./images/bg33.jpg") center;
        background-size: cover;
        padding: 0.1px;
      }
    }
  }
  .android-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .download-btn {
      width: 80%;
      height: 45px;
      background-color: #ffffff;
      border-radius: 68px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        margin-left: 5px;
        font-size: 20px;
      }
      img {
        padding-bottom: 3px;
        width: 24px;
        height: 24px;
      }
    }
    .download-ios {
      width: 80%;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      text-align: center;
      p {
        flex: 1;
        width: 50%;
        height: 35px;
        margin: 0 0px 10px 0px; // 间隙为5px
        background-color: #ffffff;
        border-radius: 30px;
        text-align: center;
        line-height: 35px;
        min-width: 48%;
        max-width: 48%;
        font-weight: 700;
      }
    }
    .tip {
      color: #ffffff;
      font-size: 14px;
      text-align: center;
      img {
        vertical-align: middle;
        width: 15px;
        height: 15px;
      }
    }
    .tip-ios {
      &.abc {
        opacity: 0;
      }
    }
  }
  .ios-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(65, 60, 60, 0.6);
    display: flex;
    justify-content: space-between;
    padding: 10px 10px;
    border-bottom: 1px rgba(65, 60, 60, 0.6) solid;
    img {
      width: 118px;
      height: 48px;
      object-fit: cover;
    }
    .right {
      font-size: 12px;
      color: #ffffff;
      .fix-btn {
        margin-bottom: 5px;
        background-image: linear-gradient(270deg, #ed4a40 0%, #f28e3e 100%);
        width: 126px;
        height: 31px;
        text-align: center;
        line-height: 31px;
        border-radius: 15px;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
}

// xhy104css
.xhy-four {
  // width: 100vw;
  height: 100vh;
  overflow-x: scroll;
  background-size: 100% 100%;
  background: #080a0b;
  .bg-image {
    width: 100%;
    background: url("../XhyFour/images/bg@2x.png") no-repeat;
    background-size: cover;
    margin-top: 20px;
    opacity: 0.850000011920929;
    .content {
      width: 100%;
      height: 500px;
      img {
        width: 100%;
        height: 100%;
      }
      .title {
        width: 170px;
        margin: 0 auto;
        padding-top: 25px;
      }
      .title-two {
        width: 324px;
        height: 66px;
        margin: 25px auto 30px;
      }
      .center {
        width: 338px;
        margin: 0 auto;
      }
      .btn {
        width: 315px;
        height: 54px;
        border-radius: 8px;
        background: #131313e0;
        border: 1px solid #ffe362;
        margin: 30px auto;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          margin: 0%;
        }
        .btn-ios {
          display: flex;
          align-items: center;
          justify-content: space-around;
          color: #ffffff;
          font-weight: medium;
          font-size: 15px;
          width: 180px;
          p:last-child {
            color: #ffe362;
            font-weight: medium;
            font-size: 12px;
            text-align: center;
            padding-top: 5px;
          }
        }
      }
      .busines {
        display: flex;
        align-items: center;
        justify-content: center;
        .line {
          width: 80px;
          border-top: 0.1px solid #eaeaea;
        }
        p {
          color: #ffffff;
          font-size: 15px;
          // padding: 0 10px;
        }
      }
      .business-logo {
        width: 315px;
        border-radius: 8px;
        background: #202022;
        margin: 24px auto 26px;
        padding: 10px 0;
        div {
          width: 110px;
          display: flex;
          justify-content: space-between;
          margin: 0 auto;
          img {
            width: 50px;
            height: 50px;
          }
        }
      }
      .telegram {
        display: flex;
        align-items: center;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        width: 130px;
        margin: 0 auto;
        padding-bottom: 30px;
        p {
          margin-left: 5px;
          font-size: 14px;
          color: #ffe362;
        }
      }
    }
  }
  .box {
    width: 66px;
    position: relative;
    top: 25px;
    left: 274px;
  }
  .box-service {
    width: 66px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      color: #ffe362;
      font-size: 14px;
    }
  }
}
.ios_down_list_view {
  border-radius: 20px 20px 0 0;
  padding-bottom: 20px;
  .ios_down_list_content {
    p {
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      margin: 15px 0;
    }
  }
  .message-box {
    text-align: center;
    img {
      width: 202px;
      height: 24px;
      margin: 0 auto;
    }
  }
  .list_item {
    width: 351px;
    height: 104px;
    box-sizing: border-box;
    margin: 15px auto 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      position: absolute;
      right: 20px;
      top: -6px;
      width: 87px;
      height: 20px;
      background-size: 100% 100%;
      background-position: left center;
    }
  }
}
</style>
